import { baseTheme } from './baseTheme'

export const theme = {
  font: {
    // если использовать переменные не подставляются значения
    ...baseTheme.font,
    family: {
      MTSWide: 'var(--old_font-family-MTSWide)',
      MTSCompact: 'var(--old_font-family-MTSCompact)',
      MTSText: 'var(--old_font-family-MTSText)',
      MTSSans: 'var(--old_font-family-MTSSans)',
      MTSExtended: 'var(--old_font-family-MTSExtended)',
    },
  },
  colors: {
    bg: {
      white: 'var(--old_colors-bg-white)',
      primary: 'var(--old_colors-bg-primary)',
      secondary: 'var(--old_colors-bg-secondary)',
      tertiary: 'var(--old_colors-bg-tertiary)',
      black: 'var(--old_colors-bg-black)',
      footer: 'var(--old_colors-bg-footer)',
      stroke: 'var(--old_colors-bg-stroke)',
      overlay: 'var(--old_colors-bg-overlay)',
      transparent: 'var(--old_colors-bg-transparent)',
      grey600: 'var(--old_colors-bg-grey600)',
      grey500: 'var(--old_colors-bg-grey500)',
      grey300: 'var(--old_colors-bg-grey300)',
      infoCard: 'var(--old_colors-bg-infoCard)',
    },
    icon: {
      primary: 'var(--old_colors-icon-primary)',
      secondary: 'var(--old_colors-icon-secondary)',
      tertiary: 'var(--old_colors-icon-tertiary)',
      white: 'var(--old_colors-icon-white)',
      emerald: 'var(--old_colors-icon-emerald)',
      orange: 'var(--old_colors-icon-orange)',
      grey600: 'var(--old_colors-icon-grey600)',
      grey500: 'var(--old_colors-icon-grey500)',
      grey300: 'var(--old_colors-icon-grey300)',
      warning: 'var(--old_colors-icon-warning)',
      resultButton: 'var(--old_colors-icon-resultButton)',
      close: 'var(--old_colors-icon-close)',
      footer: 'var(--old_colors-icon-footer)',
    },
    text: {
      black: 'var(--old_colors-text-black)',
      white: 'var(--old_colors-text-white)',
      primary: 'var(--old_colors-text-primary)',
      secondary: 'var(--old_colors-text-secondary)',
      tertiary: 'var(--old_colors-text-tertiary)',
      negative: 'var(--old_colors-text-negative)',
      primaryLink: 'var(--old_colors-text-primaryLink)',
      grey600: 'var(--old_colors-text-grey600)',
      grey500: 'var(--old_colors-text-grey500)',
      grey300: 'var(--old_colors-text-grey300)',
      resultButton: 'var(--old_colors-text-resultButton)',
      footer: 'var(--old_colors-text-footer)',
      infoCard: 'var(--old_colors-text-infoCard)',
    },
    state: {
      active: 'var(--old_colors-state-active)',
      error: 'var(--old_colors-state-error)',
      tap: 'var(--old_colors-state-tap)',
      hover: 'var(--old_colors-state-hover)',
      buttonActive: 'var(--old_colors-state-buttonActive)',
      inputHover: 'var(--old_colors-state-inputHover)',
      secondaryActive: 'var(--old_colors-state-secondaryActive)',
      secondaryTap: 'var(--old_colors-state-secondaryTap)',
      secondaryHover: 'var(--old_colors-state-secondaryHover)',
      alternativeSecondary: 'var(--old_colors-state-alternativeSecondary)',
      alternativeSecondaryTap: 'var(--old_colors-state-alternativeSecondaryTap)',
      alternativeSecondaryHover: 'var(--old_colors-state-alternativeSecondaryHover)',
      primaryLinkHover: 'var(--old_colors-state-primaryLinkHover)',
      autocompleteBorder: 'var(--old_colors-state-autocompleteBorder)',
      suggestionHover: 'var(--old_colors-state-suggestionHover)',
    },
    resultButton: {
      default: 'var(--old_colors-resultButton-default)',
      hover: 'var(--old_colors-resultButton-hover)',
      active: 'var(--old_colors-resultButton-active)',
      shadow: 'var(--old_colors-resultButton-shadow)',
    },
    chat: {
      bg: {
        primary: 'var(--old_colors-chat-bg-primary)',
        primaryElevated: 'var(--old_colors-chat-bg-primaryElevated)',
        secondary: 'var(--old_colors-chat-bg-secondary)',
        tertiary: 'var(--old_colors-chat-bg-tertiary)',
      },
      brand: {
        color: 'var(--old_colors-chat-brand-color)',
        color20: 'var(--old_colors-chat-brand-color20)',
      },
      icon: {
        brand: 'var(--old_colors-chat-icon-brand)',
        inverted: 'var(--old_colors-chat-icon-inverted)',
        primary: 'var(--old_colors-chat-icon-primary)',
        secondary: 'var(--old_colors-chat-icon-secondary)',
        tertiary: 'var(--old_colors-chat-icon-tertiary)',
      },
      stroke: {
        bg: 'var(--old_colors-chat-stroke-bg)',
      },
      text: {
        inverted: 'var(--old_colors-chat-text-inverted)',
        link: 'var(--old_colors-chat-text-link)',
        negative: 'var(--old_colors-chat-text-negative)',
        positive: 'var(--old_colors-chat-text-positive)',
        primary: 'var(--old_colors-chat-text-primary)',
        secondary: 'var(--old_colors-chat-text-secondary)',
        tertiary: 'var(--old_colors-chat-text-tertiary)',
      },
    },
  },
}
